<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="categoryId" >
        <span slot="label" ><a-tooltip>{{ $t('小组分类') }}<template slot="title">{{ $t('小组分类') }}</template></a-tooltip> </span>
        <a-select v-model="form.categoryId" :placeholder="$t('请选择')+'小组分类'" allow-clear>
          <a-select-option v-for="item in categoryList" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
        </a-select>
      </a-form-model-item>
     <a-form-model-item prop="ownerId" >
        <span slot="label" ><a-tooltip>{{ $t('组长用户ID') }}<template slot="title">{{ $t('组长用户ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.ownerId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'组长用户ID'" />
     </a-form-model-item>
      <a-form-model-item prop="groupName" >
        <span slot="label" ><a-tooltip>{{ $t('小组名称') }}<template slot="title">{{ $t('小组名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.groupName" :maxLength="64" :placeholder="$t('请输入')+'小组名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="groupAvatar" >
        <span slot="label" ><a-tooltip>{{ $t('小组头像URL') }}<template slot="title">{{ $t('小组头像URL') }}</template></a-tooltip> </span>
        <oss-upload-single :height="100" :width="100" v-model="form.groupAvatar" prefix="community" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="groupCover" >
        <span slot="label" ><a-tooltip>{{ $t('小组封面URL') }}<template slot="title">{{ $t('小组封面URL') }}</template></a-tooltip> </span>
        <oss-upload-single :height="200" :width="360" v-model="form.groupCover" prefix="community" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="summary" >
        <span slot="label" ><a-tooltip>{{ $t('小组简介摘要') }}<template slot="title">{{ $t('小组简介摘要') }}</template></a-tooltip> </span>
        <a-input v-model="form.summary" :maxLength="255" :placeholder="$t('请输入')+'小组简介摘要'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="joinType" >
        <span slot="label" ><a-tooltip>{{ $t('加入方式') }}<template slot="title">{{ $t('加入方式：10-自由加入，20-审核加入，30-仅邀请加入') }}</template></a-tooltip> </span>
        <a-select v-model="form.joinType" :placeholder="$t('请选择')+'加入方式'">
          <a-select-option :value="10">{{ $t('自由加入') }}</a-select-option>
          <a-select-option :value="20">{{ $t('审核加入') }}</a-select-option>
          <a-select-option :value="30">{{ $t('仅邀请加入') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="groupStatus" >
        <span slot="label" ><a-tooltip>{{ $t('小组状态') }}<template slot="title">{{ $t('小组状态：1010-正常，1020-待审核，1030-审核拒绝，1040-已禁用') }}</template></a-tooltip> </span>
        <a-select v-model="form.groupStatus" :placeholder="$t('请选择')+'小组状态'">
          <a-select-option :value="1010">{{ $t('正常') }}</a-select-option>
          <a-select-option :value="1020">{{ $t('待审核') }}</a-select-option>
          <a-select-option :value="1030">{{ $t('审核拒绝') }}</a-select-option>
          <a-select-option :value="1040">{{ $t('已禁用') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="isRecommend" >
        <span slot="label" ><a-tooltip>{{ $t('是否推荐') }}<template slot="title">{{ $t('1-推荐，0-不推荐') }}</template></a-tooltip> </span>
        <a-select v-model="form.isRecommend" :placeholder="$t('请选择')+'是否推荐'">
          <a-select-option :value="0">{{ $t('不推荐') }}</a-select-option>
          <a-select-option :value="1">{{ $t('推荐') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="isOfficial" >
        <span slot="label" ><a-tooltip>{{ $t('是否官方小组') }}<template slot="title">{{ $t('1-是，0-否') }}</template></a-tooltip> </span>
        <a-select v-model="form.isOfficial" :placeholder="$t('请选择')+'是否官方小组'">
          <a-select-option :value="0">{{ $t('否') }}</a-select-option>
          <a-select-option :value="1">{{ $t('是') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="isMute" >
        <span slot="label" ><a-tooltip>{{ $t('是否全员禁言') }}<template slot="title">{{ $t('1-是，0-否') }}</template></a-tooltip> </span>
        <a-select v-model="form.isMute" :placeholder="$t('请选择')+'是否全员禁言'">
          <a-select-option :value="0">{{ $t('否') }}</a-select-option>
          <a-select-option :value="1">{{ $t('是') }}</a-select-option>
        </a-select>
      </a-form-model-item>
     <a-form-model-item prop="auditReason" >
        <span slot="label" ><a-tooltip>{{ $t('审核原因') }}<template slot="title">{{ $t('审核原因') }}</template></a-tooltip> </span>
        <a-input v-model="form.auditReason" :maxLength="255" :placeholder="$t('请输入')+'审核原因'" >
       </a-input>
     </a-form-model-item>
     <a-form-model-item prop="sort" >
        <span slot="label" ><a-tooltip>{{ $t('排序值') }}<template slot="title">{{ $t('排序值') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.sort" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'排序值'" />
     </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
 import { getCommunityGroup, addCommunityGroup, updateCommunityGroup } from '@/api/community/communityGroup/communityGroup'
  import { listCommunityGroupCategory } from '@/api/community/communityGroup/communityGroupCategory'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
      OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
     // 表单参数
      categoryList: [],
     form: {
       categoryId: null,
       ownerId: null,
       groupName: null,
       groupAvatar: null,
       groupCover: null,
       summary: null,
       joinType: null,
        groupStatus: 1010,
       isRecommend: null,
       isOfficial: null,
       isMute: null,
       auditReason: null,
       sort: null,
       remark: null,
       localeFieldMap: {}
     },
      // 1增加,2修改
      formType: 1,
      open: false,
     rules: {
          categoryId: [{ required: true, message: this.$t('小组分类') + this.$t('不能为空'), trigger: 'blur' }],
         groupName: [{ required: true, message: this.$t('小组名称') + this.$t('不能为空'), trigger: 'blur' }],
         groupCover: [{ required: true, message: this.$t('小组封面URL') + this.$t('不能为空'), trigger: 'blur' }],
         summary: [{ required: true, message: this.$t('小组简介摘要') + this.$t('不能为空'), trigger: 'blur' }],
          joinType: [{ required: true, message: this.$t('加入方式：10-自由加入，20-审核加入，30-仅邀请加入') + this.$t('不能为空'), trigger: 'change' }],
           isRecommend: [{ required: true, message: this.$t('是否推荐：1-推荐，0-不推荐') + this.$t('不能为空'), trigger: 'blur' }],
           isOfficial: [{ required: true, message: this.$t('是否官方小组：1-是，0-否') + this.$t('不能为空'), trigger: 'blur' }],
           isMute: [{ required: true, message: this.$t('是否全员禁言：1-是，0-否') + this.$t('不能为空'), trigger: 'blur' }],
            sort: [{ required: true, message: this.$t('排序值') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
 mounted () {
    this.loadCategoryList()
 },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
   // 表单重置
   reset () {
     this.formType = 1
     this.form = {
       categoryId: null,
       ownerId: null,
       groupName: null,
       groupAvatar: null,
       groupCover: null,
       summary: null,
       joinType: null,
        groupStatus: 1010,
       isRecommend: null,
       isOfficial: null,
       isMute: null,
       auditReason: null,
       sort: null,
       remark: null,
       localeFieldMap: {}
     }
   },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
      this.loadCategoryList()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroup({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
       let message = ''
       if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
           updateCommunityGroup(this.form).then(response => {
             if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('新增成功')
            addCommunityGroup(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    /** 加载小组分类列表 */
    loadCategoryList () {
      listCommunityGroupCategory({}).then(response => {
        this.categoryList = response.data || []
      })
    }
  }
  }
</script>
